import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import eyeIcon from "../../../../Assets/icons/eye 1.svg";
import editIcon from "../../../../Assets/icons/Un-Checkbox.svg";

import ROUTES_NAVIGATION from "../../../../routes/routes";
import ListPage from "../../Sales/Shared/ListPage";
import axiosInstance from "../../../services/api/API";
import Loader from "../../../customComponents/CustomLoader";

const PhysicalStockTaking = () => {

const [ physicaStockTakingData, setPhysicalStockTakingData ] = useState([])
const [totalPages, setTotalPages] = useState(0);
const [totalRecords, setTotalRecords] = useState(0);
const [currentPage, setCurrentPage] = useState(0);
const [searchQuery, setSearchQuery] = useState('');
const [loading, setLoading] = useState(true);
// const [ totalData, setTotalData ] = useState(0)
// const [ totalActive, setTotalActive ] = useState(0)
// const [ totalInactive, setTotalInactive ] = useState(0)
const [ filterFormData, setFilterFormData ] = useState({})
const [validationErrors, setValidationErrors] = useState({});

const token = localStorage.getItem("authToken");

  const navigate = useNavigate();

  const handleAddNavigation = () => {
    navigate(ROUTES_NAVIGATION.ADDPHYSICALSTOCKTAKING)
  }

  useEffect(() => {
    fetchPhysicalStockTakingList()
  },[])

  const fetchPhysicalStockTakingList = async (page = 0, pageSize = 10) => {
    try {
      setLoading(true)
      const response = await axiosInstance.post('/physicalstocktake/list', {
        orderBy:"phystkin_id desc",
        page,
        pageSize,
        searchText:searchQuery
      }, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        }
      });

      const formattedData = response?.data?.data?.data?.map((item, index) => ({
        ...item,
        "Sr No.": index + 1 + page * pageSize
      }));

      const totalRecordsData = response?.data?.data?.totalRecords
      setTotalRecords(totalRecordsData);

      setPhysicalStockTakingData(formattedData); 
      setTotalPages(Math.ceil(response?.data?.data?.totalRecords / pageSize)); 
     
    } catch (error) {
      console.error('Error fetching product list:', error);
    }
    finally{
      setLoading(false)
    }
  };

  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
    fetchPhysicalStockTakingList(newPage);
  };


  const topDataList = [
    { id: 1, title: "Total In-Stock", value: "180" },
    { id: 2, title: "Total Pending Stock", value: "170" },
    { id: 3, title: "Total Approved Stock", value: "8" },
    { id: 4, title: "Total Complete Stock", value: "2" },
  ];

  const TABLE_HEADERS = [
  "Trans. No.",
    "Trans. Date",
    "Vendor Name",
    "Reference No.",
    "Total Amount",
    "Action"
  ];

  const keyMapping = {
    "Trans. No.":"trn_no",
    "Trans. Date":"trn_date",
     "Reference No.":"ref_no",
    "Vendor Name":"companyname",
    "Total Amount": "trn_total" === null ? "No Data" : "trn_total",
    "Action":[
        //{ type: "edit", icon: editIcon, label: "Edit" },
        { type: "view", icon: eyeIcon, label: "View" },
    ],
  };

  const onEdit = (rowData) => {
    console.log("rowdata>", rowData);
    navigate(`${ROUTES_NAVIGATION.EDITPHYSICALSTOCKTAKING}`, { state: { data: rowData } });
  }

  const handleViewDetails = (rowData) => {
    console.log("rowdata>", rowData);
    navigate(`${ROUTES_NAVIGATION.PHYSICALSTOCKTAKINGDETAILS}`, { state: { data: rowData } });
  }

  const PhysicalStockTakingInputs = [
    {
      name: "department_name",
      label: "Trans No",
      placeholder:"Trans No.",
      type: "text",
      required: true,
      gridClass: "col-lg-2",
    },
    {
        name: "dob",
        label: "Trans Date",
        type: "date",
        maxDate: new Date(),
        required: true,
        gridClass: "col-lg-2",
    },
    {
      name: "department_name",
      label: "Vendor Name",
      placeholder:"Vendor Name",
      type: "text",
      required: true,
      gridClass: "col-lg-2",
    }
  ]
  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      apiCallFunction(0, 10,searchQuery); 
    }
  }  
  const handleSearchChange = (event) => {
    setSearchQuery(event.target.value);
  };
  const apiCallFunction = () =>{
    fetchPhysicalStockTakingList()
  }

  return (
    <div>
    {loading ? ( 
      <Loader />
    ) : (
      <div>
    <ListPage
    //   isButtonRequired={false}
    addButtonTitle = "Add Physical Stock Taking"
    isUploadButtonRequired={false}
      headerTopText="Logistics / Physical Stock Taking"
      headerTitle="Physical Stock Taking"
      listTitle="Physical Stock Listing"
      topDetailsList={topDataList}
      tableData={physicaStockTakingData}
      tableHeaders={TABLE_HEADERS}
      keyMapping={keyMapping}
      handleOnAddButton={handleAddNavigation}
      handlePageChange={handlePageChange}
      totalRecords={totalRecords} 
      currentPage={currentPage}
      totalPages={totalPages}
      onEdit={onEdit}
      isFilterRequired={false}
      searchQuery={searchQuery}
      setSearchQuery={setSearchQuery}
      handleViewButton={handleViewDetails}
      filterInputs={PhysicalStockTakingInputs}
      validationErrors={validationErrors}
      setValidationErrors={setValidationErrors}
      filterFormData={filterFormData}
      handleSearchChange={handleSearchChange}
      handleKeyPress={handleKeyPress} 
      apiCallFunction={apiCallFunction}
      setFilterFormData={setFilterFormData}
      searchplaceholder="Search by Vendor Name"
    />
   </div>
    )}
    </div>
  );
};

export default PhysicalStockTaking;
